module.exports = __webpack_public_path__ + "img/registradora.3c8dd399.png";